import {sentiment_negative, sentiment_neutral, sentiment_positive} from '../../../../../../../css/var-export.scss';
import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

import {AspectsToneEnum} from './aspects-tone-type';

export const aspectsToneDistributionColors: Record<AspectsToneEnum, string> = {
    [AspectsToneEnum.Negative]: sentiment_negative,
    [AspectsToneEnum.Neutral]: sentiment_neutral,
    [AspectsToneEnum.Positive]: sentiment_positive,
};

export const aspectsToneDistributionLangKeys: Record<AspectsToneEnum, LangKeyType> = {
    [AspectsToneEnum.Negative]: 'REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__ASPECTS_TONE_DISTRIBUTION__NEGATIVE',
    [AspectsToneEnum.Neutral]: 'REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__ASPECTS_TONE_DISTRIBUTION__NEUTRAL',
    [AspectsToneEnum.Positive]: 'REVIEWS_ANALYSIS__KEYWORDS_AND_TOPICS__ASPECTS_TONE_DISTRIBUTION__POSITIVE',
};
